import { useLocation } from "react-router-dom";
import Components from "../../components";
import config from "../../config";

const fulfillmentStatusMap = {
  FULFILLED: {
    text: "Teslim Edildi",
    className: "bg-green-100 text-green-700",
  },
  PENDING: { text: "Bekliyor", className: "bg-yellow-100 text-yellow-700" },
  CANCELLED: { text: "İptal Edildi", className: "bg-red-100 text-red-700" },
  CREATED: { text: "Oluşturuldu", className: "bg-blue-100 text-blue-700" },
  DRAFT: { text: "Taslak", className: "bg-gray-100 text-gray-700" },
  PARTIALLY_CANCELLED: {
    text: "Kısmen İptal",
    className: "bg-orange-100 text-orange-700",
  },
  PARTIALLY_REFUNDED: {
    text: "Kısmen İade",
    className: "bg-orange-100 text-orange-700",
  },
  REFUNDED: { text: "İade Edildi", className: "bg-purple-100 text-purple-700" },
  REFUND_REJECTED: {
    text: "İade Reddedildi",
    className: "bg-red-100 text-red-700",
  },
  REFUND_REQUESTED: {
    text: "İade Talebi",
    className: "bg-yellow-100 text-yellow-700",
  },
  WAITING_UPSELL_ACTION: {
    text: "Ek Satış Bekliyor",
    className: "bg-blue-100 text-blue-700",
  },
  default: { text: "Bilinmiyor", className: "bg-gray-200 text-gray-600" },
};

const Order = ({ data }) => {
  const location = useLocation();
  const o = location.state.order;

  const status =
    fulfillmentStatusMap[o.status] || fulfillmentStatusMap.default;

  return (
    <div className="pb-20">
      <div className="max-w-md mx-auto bg-white rounded-xl  p-4 mt-4">
        <div className="flex items-center justify-between mb-2">
          <div className="text-lg font-bold text-gray-800">{o.orderNumber}</div>
          <span
            className={`px-2 py-1 rounded-full text-xs font-semibold ${status.className}`}
          >
            {status.text}
          </span>
        </div>
        <div className="text-xs text-gray-500 mb-4">
          {new Date(o.createdAt).toLocaleDateString("tr-TR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>
        <div className="mb-4">
          <div className="text-sm font-semibold text-gray-700 mb-1">
            Teslimat Adresi
          </div>
          <div className="text-xs text-gray-600">
            {o.shippingAddress?.name}
            <br />
            {o.shippingAddress?.addressLine1}
            <br />
            {o.shippingAddress?.city?.name}, {o.shippingAddress?.country?.name}{" "}
          </div>
        </div>
        <div className="mb-4">
          <div className="text-sm font-semibold text-gray-700 mb-2">
            Ürünler
          </div>
          <ul className="flex flex-col gap-3">
            {o.orderLineItems.map((item, idx) => (
              <li
                key={idx}
                className="flex items-center gap-3 border-b border-gray-100 pb-2 last:border-b-0"
              >
                <img
                  src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${item.variant.mainImageId}/image_540.webp`}
                  alt={item.variant.name}
                  className="w-14 h-14 object-cover rounded border border-gray-200"
                />
                <div className="flex-1">
                  <div className="font-medium text-gray-800 text-sm">
                    {item.variant.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    Adet: {item.quantity}
                  </div>
                </div>
                <div className="text-xs text-gray-700 font-semibold">
                  {item.finalPrice} {o.currencySymbol}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-200">
          <span className="font-semibold text-gray-700">Toplam</span>
          <span className="text-lg font-bold text-indigo-700">
            {o.totalFinalPrice} {o.currencySymbol}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Order;
